import { Dispatch, SetStateAction, useMemo } from 'react';
import { AssistantSearchResult } from '@mews-commander/data-access';
import { AssistantSearchType, SearchType } from '../assistantSearchTypes';
import { ResultsFilterChips } from '../drawer/filterChips/ResultsFilterChips';
import { FilterStateProps, SearchStateProps } from '../Assistant';
import { AssistantFilterChips } from '../assistantSearchTypeFilters';

interface ResultComponentProps {
    searchTypeKeyList: SearchType[];
    setSearchState: Dispatch<SetStateAction<SearchStateProps>>;
    setFilterState: Dispatch<SetStateAction<FilterStateProps>>;
    selectedSearchType: AssistantSearchType;
    results?: AssistantSearchResult | null | undefined;
}

export const useResultFilterChipComponent = ({
    searchTypeKeyList,
    selectedSearchType,
    setSearchState,
    setFilterState,
    results,
}: ResultComponentProps) =>
    useMemo(() => {
        const handleClick = (value: AssistantSearchType | AssistantFilterChips) => {
            if (value) {
                setSearchState((prev) => ({
                    ...prev,
                    focused: true,
                }));
                /*
                setListItemSelectionState((prev) => ({
                    ...prev,
                    ...assistantListItemSelectionInitialState,
                })); */
            }
        };

        return (
            <ResultsFilterChips
                searchTypes={searchTypeKeyList}
                activeValue={selectedSearchType}
                handleClick={handleClick}
                results={results}
                setFilterState={setFilterState}
                selectedSearchType={selectedSearchType}
            />
        );
    }, [searchTypeKeyList, selectedSearchType, results, setFilterState, setSearchState]);
